// ink-component
import React from 'react';
import { DocumentInitOptions, BoundingBoxType } from './types';
import Text from '../Typography/Text/Text';

export interface PdfViewerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Path to desired PDF */
  url: string;
  /** Additional document initialization/loading parameters (ex. can be used for authentication) */
  documentInitOptions?: DocumentInitOptions;
  /** Displays a title on the left side of the menu bar */
  title?: string;
  /** Defines the height of the PdfViewer component. Units are in vh. Use `fill` when you need the PdfViewer to occupy the available height of its parent container */
  height?: number | 'fill';
  /** Defines the initial scale of the document pages. Value between 0.25 and 10, inclusive (i.e. [0.25,10]) */
  initialScale?: number;
  /** Displays the top menu bar. Includes scale and download functionalities */
  showMenu?: boolean;
  /** Array defining bounding box selections with relative positioning. See [ReadMe](https://github.com/carta/carta-frontend-platform/blob/master/libs/design-technology/pdfviewer/README.md#bounding-boxes) for further specifications */
  boundingBoxes?: BoundingBoxType[];
  /** Enables editability of bounding boxes */
  isEditable?: boolean;
  /** Callback when changes are made to boundingBoxes */
  onBoundingBoxesChange?: (updatedBoundingBoxes: BoundingBoxType[]) => void;
  /** Callback when isEditing state changes */
  onIsEditingChange?: (isEditing: boolean) => void;
  /** Marks the element with a given ID to make it easier to select on tests */
  'data-testid'?: string | number;
}

/**
 * This is a placeholder component for an external Ink component:
 * https://github.com/carta/carta-frontend-platform/blob/master/libs/design-technology/pdfviewer/library/PdfViewer/PdfViewer.tsx
 */

/**
 * @purpose PDF viewer with ability to display bounding boxes encompassing desired selections
 * @categories PdfViewer
 * @status external
 * @externalImplementationLink https://github.com/carta/carta-frontend-platform/tree/master/libs/design-technology/pdfviewer
 */
function PdfViewer(props: PdfViewerProps) {
  return (
    <Text align="left">
      You are using a dummy component that acts as a placeholder for @carta/pdfviewer for documentation purposes. To use
      PdfViewer, install it via yarn add @carta/pdfviewer.
    </Text>
  );
}

PdfViewer.defaultProps = {
  showMenu: true,
  initialScale: 1,
  height: 100,
  isEditable: false,
};

PdfViewer.displayName = 'PdfViewer';

export default PdfViewer;
